/**
 * Cross/X icon for failed timeline events.
 * Color: Red (#EF4444) for failed/declined events
 * Size controlled by CSS: 16x16
 */
export const CrossIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="12" fill="#FEE2E2" />
    <path
      d="M8 8L16 16M16 8L8 16"
      stroke="#EF4444"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
